import config from './firebase';

export const firebaseConfig = config.firebaseConfig;
export const cloudFunctionConfig = config.cloudFunctionsConfig;
